var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 1.66666H3.33335C2.41288 1.66666 1.66669 2.41285 1.66669 3.33332V16.6667C1.66669 17.5871 2.41288 18.3333 3.33335 18.3333H6.66669C7.58716 18.3333 8.33335 17.5871 8.33335 16.6667V3.33332C8.33335 2.41285 7.58716 1.66666 6.66669 1.66666Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 1.66666H13.3334C12.4129 1.66666 11.6667 2.41285 11.6667 3.33332V6.66666C11.6667 7.58713 12.4129 8.33332 13.3334 8.33332H16.6667C17.5872 8.33332 18.3334 7.58713 18.3334 6.66666V3.33332C18.3334 2.41285 17.5872 1.66666 16.6667 1.66666Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 11.6667H13.3334C12.4129 11.6667 11.6667 12.4128 11.6667 13.3333V16.6667C11.6667 17.5871 12.4129 18.3333 13.3334 18.3333H16.6667C17.5872 18.3333 18.3334 17.5871 18.3334 16.6667V13.3333C18.3334 12.4128 17.5872 11.6667 16.6667 11.6667Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.84e84599e912bf3010d11ef08765a445.svg";
export { ForwardRef as ReactComponent };